export default {"src":"/_next/static/media/WhoWeAre_034A.69404695.JPG","height":690,"width":1920};